var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 2500,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "-584.5248496097993 0 9625.3248496098 12857.64",
    width: 1774,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6138.41 5026.91l1454.34-1343.6 890.69-1427.18C7929.7 1287.59 7003.71 544.15 5891 203.81L4223.67 1342.39l-988.29 1925.39c316.16-351.86 774.72-573.24 1285.02-573.24 953.87 0 1727.13 773.27 1727.13 1727.14 0 212.92-38.6 416.89-109.12 605.23zM3197.19 3311.78l-5.08 5.89.08.08z",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4520.4 0c2496.61 0 4520.4 1947.47 4520.4 4349.87 0 942.42-311.48 1814.74-840.72 2527.08h.08S5821.13 10192.36 5448 10949.34c-373.14 756.99-447.76 1417.99-607.74 1663.15-159.97 245.15-522.38 127.98-607.65-223.88-85.26-351.86-383.85-1076.77-1044.85-2185.62C2526.75 9094.15 862.72 6906.36 862.72 6906.36h.32C320.35 6188.7 0 5305.35 0 4349.87 0 1947.47 2023.79 0 4520.4 0zm0 2694.54c953.87 0 1727.13 773.27 1727.13 1727.14 0 953.86-773.26 1727.13-1727.13 1727.13s-1727.13-773.27-1727.13-1727.13c0-953.87 773.26-1727.14 1727.13-1727.14z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2565.28 9248.72l2819.61-3331.61c343.88-199.22 612.65-513.6 753.61-890.36l2344.86-2770.7c355.16 621.19 557.44 1334.74 557.44 2093.82 0 942.42-311.48 1814.74-840.72 2527.08h.08S5821.13 10192.36 5448 10949.34c-373.14 756.99-447.76 1417.99-607.74 1663.15-159.97 245.15-522.38 127.98-607.65-223.88-85.26-351.86-383.85-1076.77-1044.85-2185.62-160.86-269.89-381.2-603.7-622.48-954.27z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M571.31 6467.63l2620.8-3149.96.08.08c-249.03 299.31-398.92 684.13-398.92 1103.93 0 953.86 773.26 1727.13 1727.13 1727.13 315.03 0 610.31-84.38 864.57-231.7L2565.28 9248.72C1815.3 8158.74 862.72 6906.36 862.72 6906.36h.32a4348.631 4348.631 0 0 1-291.73-438.73z",
    fill: "#fbbc04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M996.34 1625.83l2218.49 1665.08L571.31 6467.63C207.52 5840.95 0 5248.86 0 4349.87s375.55-1979.14 996.34-2724.04z",
    fill: "#ea4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5891 203.81l-2676.17 3087.1L996.34 1625.83C1824.81 634.57 3095.48 0 4520.4 0c477.82 0 938.31 71.56 1370.6 203.81z",
    fill: "#1a73e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google-maps.5ccf382ef3d649d3697997d033a172bd.svg";
export { ForwardRef as ReactComponent };